<template>
  <div>
    <van-cell title="服务类型" is-link value="轮胎快修服务">
      <template #right-icon>
        <van-icon name="warning" class="warning" @click="show = true" />
      </template>
    </van-cell>
  </div>
  <van-dialog v-model:show="show" title="轮胎标识">
    <div class="fhudl">
      <div class="fvlu">
        <div class="qa fc">问&nbsp;</div>
        <span>{{ qa.q }}</span>
      </div>
      <div class="fvlu">
        <div class="qa fc">答&nbsp;</div>
        <span>{{ qa.a }}</span>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import { reactive, toRefs } from 'vue'
export default {
  props: ['datas'],
  setup(props) {
    let { datas } = toRefs(props)
    const state = reactive({
      show: false,
      popUpcontent: { content: datas, title: '服务类型' },
      qa: {
        q: '什么是轮胎快修服务 ？',
        a: '如果您的爱车只需更换轮胎，请您与经销商提前预约，便可在到店后享受轮胎服务专属的绿色通道，到店即换，无须等待。'
      }
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.van-cell__title) {
  display: flex;
  justify-content: flex-start;
}
.warning {
  font-size: 14px;
  color: #cccccc;
  line-height: inherit;
  margin-left: 6px;
}
.fhudl {
  padding: 10px 20px;
  font-size: 14px;
}
.fvlu {
  margin-bottom: 8px;
  span {
    text-align: left;
  }
}
.qa {
  font-size: 12px;
  background: #3088c5;
  color: #ffffff;
  padding: 1px 3px 2px;
  transform: scale(0.8);
  border-radius: 5px;
}
</style>
